<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">
      <form (ngSubmit)="login()" class="login100-form validate-form">
        <div
          class="Frame11"
          style="
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 72px;
            display: inline-flex;
          "
        >
          <div
            class="Frame54"
            style="
              align-self: stretch;
              height: 87px;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              display: flex;
            "
          >
            <div
              class="Frame7"
              style="
                align-self: stretch;
                justify-content: center;
                align-items: flex-start;
                gap: 5.89px;
                display: inline-flex;
              "
            >
              <div
                class="Frame14"
                style="
                  flex: 1 1 0;
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: flex-start;
                  display: inline-flex;
                "
              >
                <div
                  class="Frame54"
                  style="
                    align-self: stretch;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 16px;
                    display: inline-flex;
                  "
                >
                  <div
                    class="Frame13"
                    style="
                      justify-content: flex-start;
                      align-items: center;
                      gap: 5.89px;
                      display: flex;
                    "
                  >
                    <div
                      class="Frame6"
                      style="
                        padding: 11.79px;
                        border-radius: 47.16px;
                        border: 2.21px #05477b solid;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 5.89px;
                        display: flex;
                      "
                    >
                      <img
                        style="
                          width: 30.95px;
                          height: 30.95px;
                          position: relative;
                        "
                        src="../../../assets/images/luggage.png"
                      />
                    </div>
                  </div>
                  <div
                    class="Tourist"
                    style="
                      color: #05477b;
                      font-size: 56px;
                      font-family: Roboto;
                      font-weight: 300;
                      line-height: 67.2px;
                      word-wrap: break-word;
                    "
                  >
                    Tourist
                  </div>
                </div>
                <div
                  class="Frame4"
                  style="
                    align-self: stretch;
                    padding-left: 80px;
                    justify-content: flex-start;
                    align-items: flex-start;
                    gap: 5.89px;
                    display: inline-flex;
                  "
                >
                  <div
                    class="SimplifyYourTouristTaxToday"
                    style="
                      color: #424242;
                      font-size: 11.05px;
                      font-family: Roboto;
                      font-weight: 500;
                      text-transform: uppercase;
                      line-height: 19.16px;
                      letter-spacing: 0.34px;
                      word-wrap: break-word;
                    "
                  >
                    Simplify Your Tourist Tax
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="Frame55"
            style="
              align-self: stretch;
              height: 22px;
              justify-content: center;
              align-items: center;
              gap: 8px;
              display: inline-flex;
            "
          >
            <mat-label>Don’t have an account ?</mat-label>
            <mat-label
              (click)="redirectToAnotherRoute()"
              style="cursor: pointer; color: #2196f3"
              [routerLink]="['/register/createAccount']"
              >Create one here</mat-label
            >
          </div>
          <div
            class="Frame53"
            style="
              align-self: stretch;
              height: 256px;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 32px;
              display: flex;
            "
          >
            <div
              class="Frame32"
              style="
                align-self: stretch;
                height: 26px;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 8px;
                display: flex;
              "
            >
              <div
                class="Formlabel"
                style="
                  flex-direction: column;
                  justify-content: flex-start;
                  align-items: flex-start;
                  display: flex;
                "
              >
                <div
                  class="Label"
                  style="
                    color: rgba(0, 0, 0, 0.87);
                    font-size: 15px;
                    font-family: Roboto;
                    font-weight: 500;
                    text-transform: uppercase;
                    line-height: 26px;
                    letter-spacing: 0.46px;
                    word-wrap: break-word;
                  "
                >
                  Login
                </div>
              </div>
            </div>
            <div class="from-body">
              <div class="form-elements">
                <mat-form-field
                  appearance="outline"
                >
                  <mat-label>Email address</mat-label>
                  <input
                    matInput
                    type="email"
                    [formControl]="emailFormControl"
                    required
                  />
                  <mat-error
                    *ngIf="
                      emailFormControl.hasError('email') &&
                      !emailFormControl.hasError('required')
                    "
                  >
                    Please enter a valid email address
                  </mat-error>
                  <mat-error *ngIf="emailFormControl.hasError('required')">
                    Email is required
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                >
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    type="password"
                    [type]="hide ? 'password' : 'text'"
                    [formControl]="passwordFormControl"
                    required
                  />
                  <mat-icon matSuffix (click)="hide = !hide">{{
                    hide ? "visibility_off" : "visibility"
                  }}</mat-icon>
                  <mat-error *ngIf="passwordFormControl.hasError('required')">
                    Password is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="login-form-button">
                <button type="submit" mat-raised-button color="primary">
                  LOGIN
                  <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="login-form-footer">
            <mat-checkbox class="" color="primary" value="after"
              >Remember me</mat-checkbox
            >
            <div
              class="Button"
              style="
                align-self: stretch;
                height: 42px;
                padding-left: 8px;
                padding-right: 8px;
                border-radius: 4px;
                overflow: hidden;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                display: flex;
              "
            >
              <div
                class="Base"
                style="
                  justify-content: center;
                  align-items: center;
                  gap: 8px;
                  display: inline-flex;
                "
              >
                <div
                  (click)="forgotPassword()"
                  class="Button"
                  style="
                    cursor: pointer;
                    color: #2196f3;
                    font-size: 16px;
                    font-family: Roboto;
                    font-weight: 400;
                    line-height: 28px;
                    letter-spacing: 0.15px;
                    word-wrap: break-word;
                  "
                >
                  Forgot your password ?
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div
        class="login100-more"
        style="
          background-image: url('../.././../assets/images/loginImage2.jpeg');
        "
      ></div>
    </div>
  </div>
</div>
